// extracted by mini-css-extract-plugin
module.exports = {"green-card-landing":"GreenCardLanding_green-card-landing__Ro0Xd"};